import { utils } from 'ethers'

import ILaunchpadIDOABI from '../../abi/ILaunchpadIDO.abi.json'

export const launchpadInterface = new utils.Interface(ILaunchpadIDOABI)
